<template>
	<div class="home-page" style="background-color: #001A33; width: 100%; height: 100%; max-height: 100%; overflow: hidden; box-sizing: border-box;">
		<div class="home-dashboard" style="display: flex;margin-left: 22px;width: calc(100% - 35px);height: calc(100% - 40px);">
			<!-- 左侧列：发电数据+经济收益+发电效益 -->
			<div class="home-side-column home-left-column">
				<div class="dashboard-panel power-data-panel" style="width: 384px;background-color: #002B4D;height: 278px;border: 1px solid #0099FF;border-radius: 6px;">
					<div class="panel-header" style="height: 48px;width: 100%;border-bottom: 2px solid #003C66;display: flex;align-items: center;">
						<div class="panel-title-icon" style="margin-left: 20px;margin-top: 0;">
							<img src="../../../static/充电桩设备总数统计(1).png"/>
						</div>
						<div class="panel-title" style="color: #87CEFA;font-size: 14px;line-height: 48px;margin-left: 10px;">
							发电数据
						</div>
					</div>
					<div class="power-data-grid" style="width: calc(100% - 40px);margin-left: 20px;">
						<div class="metric-card power-data-card" style="height: 170px;margin-top: 10px;display: flex;background-color: #001A33;border: 1px solid #0099FF;border-radius: 4px;align-items: center;">
							<div class="metric-label" style="line-height: 7vh;font-size: 0.9vw;color: #87CEFA;margin-left: 10px;">
								日发电量
							</div>
							<div class="metric-icon" style="margin-top: 0;">
								<img src="../../../static/日发电量 (2).png" style="width: 3.5vw;height: 6.8vh;"/>
							</div>
							<div class="metric-value" style="line-height: 7vh;font-size: 1.0vw;color: #B0E2FF;margin-left: 1vw;font-weight: bold;">
								<span class="metric-number">{{formatNumber(powerGenerationData.dayPowerGeneration, 2)}}</span>
								<span class="metric-unit">kwh</span>
							</div>
						</div>
						<div class="metric-card power-data-card" style="height:170px;margin-top: 10px;display: flex;background-color: #001A33;border: 1px solid #0099FF;border-radius: 4px;align-items: center;">
							<div class="metric-label" style="line-height: 7vh;font-size: 0.9vw;color: #87CEFA;margin-left: 10px;">
								月发电量
							</div>
							<div class="metric-icon" style="margin-top: 0px;">
								<img src="../../../static/月发电量 (1).png" style="width: 3.5vw;height: 6.8vh;"/>
							</div>
							<div class="metric-value" style="line-height: 7vh;font-size: 1.0vw;color: #B0E2FF;margin-left: 1vw;font-weight: bold;">
								<span class="metric-number">{{formatNumber(powerGenerationData.monthPowerGeneration, 2)}}</span>
								<span class="metric-unit">kwh</span>
							</div>
						</div>
						<div class="metric-card power-data-card" style="height:170px;margin-top: 10px;display: flex;background-color: #001A33;border: 1px solid #0099FF;border-radius: 4px;align-items: center;">
							<div class="metric-label" style="line-height: 7vh;font-size: 0.9vw;color: #87CEFA;margin-left: 10px;">
								总发电量
							</div>
							<div class="metric-icon" style="margin-top: 2px;">
								<img src="../../../static/年发电量.png" style="width: 3.5vw;height: 6.8vh;"/>
							</div>
							<div class="metric-value" style="line-height: 7vh;font-size: 1.0vw;color: #B0E2FF;margin-left: 1vw;font-weight: bold;">
								<span class="metric-number">{{formatNumber(powerGenerationData.totalPowerGeneration, 2)}}</span>
								<span class="metric-unit">kwh</span>
							</div>
						</div>
					</div>
				</div>
				<div class="dashboard-panel income-panel" style="width: 384px;background-color: #002B4D;height: 220px;margin-top: 20px;border: 1px solid #0099FF;border-radius: 6px;">
					<div class="panel-header" style="height: 48px;width: 100%;border-bottom: 2px solid #003C66;display: flex;align-items: center;">
						<div class="panel-title-icon" style="margin-left: 20px;margin-top: 0;">
							<img src="../../../static/经济效益(1).png"/>
						</div>
						<div class="panel-title" style="color: #87CEFA;font-size: 14px;line-height: 48px;margin-left: 10px;">
							经济收益
						</div>
					</div>
					<div class="income-grid" style="display: flex;margin-left: 19px;">
						<div class="metric-card" style="margin-top: 10px;height: 155px;border-radius: 6px;background-color: #001A33;width: 110px;text-align: center;border: 1px solid #0099FF;">
							<div style="margin-top: 10px;color: #87CEFA;font-size: 0.9vw;">
								日发电收益
							</div>
							<div style="margin-top: 8px;">
								<img src="../../../static/今日收益.png" style="width: 2.2vw;height: 3.8vh;"/>
							</div>
							<!-- 日收益 保留2位小数 -->
							<div style="margin-top: 6px;color: #00CCFF;font-size: 0.9vw;font-weight: bold;">
								<span class="income-value-number">{{incomeData.dayIncome ? Number(incomeData.dayIncome).toFixed(2) : '0.00'}}</span>
								<span class="income-value-unit">元</span>
							</div>

						</div>
						<div class="metric-card" style="margin-top: 10px;height: 155px;margin-left: 10px;border-radius: 6px;background-color: #001A33;width: 110px;text-align: center;border: 1px solid #0099FF;">
							<div style="margin-top: 10px;color: #87CEFA;font-size: 0.9vw;">
								月发电收益
							</div>
							<div style="margin-top: 8px;">
								<img src="../../../static/本月收益.png" style="width: 2.2vw;height: 3.8vh;"/>
							</div>
							<!-- 月收益 保留2位小数 -->
							<div style="margin-top: 6px;color: #00CCFF;font-size: 0.9vw;font-weight: bold;">
								<span class="income-value-number">{{incomeData.monthIncome ? Number(incomeData.monthIncome).toFixed(2) : '0.00'}}</span>
								<span class="income-value-unit">元</span>
							</div>

						</div>
						<div class="metric-card" style="margin-top: 10px;height: 155px;margin-left: 10px;background-color: #001A33;width: 110px;text-align: center;border-radius: 6px;border: 1px solid #0099FF;">
							<div style="margin-top: 10px;color: #87CEFA;font-size: 0.9vw;">
								总发电收益
							</div>
							<div style="margin-top: 8px;">
								<img src="../../../static/本年收益 (1).png" style="width: 2.2vw;height: 3.8vh;"/>
							</div>
							<!-- 总收益 保留2位小数 -->
							<div style="margin-top: 6px;color: #00CCFF;font-size: 0.9vw;font-weight: bold;">
								<span class="income-value-number">{{incomeData.totalIncome ? Number(incomeData.totalIncome).toFixed(2) : '0.00'}}</span>
								<span class="income-value-unit">元</span>
							</div>

						</div>
					</div>
				</div>
				<!-- 发电效益模块整体容器：调整高度为350px（给滚动容器更多空间），宽度100%保留 -->
	<div style="width:100%;background-color: #002B4D;height: 290px;margin-top: 20px;border: 1px solid #0099FF;border-radius: 6px;">
		<div style="height: 48px;width:100%;border-bottom: 2px solid #003C66;display: flex;align-items: center;">
			<div style="margin-left: 20px;margin-top: 0;">
				<img src="../../../static/发电机(1).png"/>
			</div>
			<div style="color: #87CEFA;font-size: 14px;line-height: 48px;margin-left: 10px;">
				发电效益
			</div>
		</div>
		<!-- 表头容器：修复宽度计算的空格问题，优化发电量列的位置（避免固定margin-left导致适配问题） -->
		<div class="fdxl-table-header" style="height: 40px;line-height: 40px;background-color: #001A33;font-weight: bolder;margin-top: 10px;margin-left: 20px;width: calc(100% - 40px);display: flex;font-size: 14px;color: #B0E2FF;border: 1px solid #0099FF;border-radius: 4px;">
			<div style="width: 38%;text-align: center;padding: 0 14px;box-sizing: border-box;">
				电站名称
			</div>
			<div style="width: 62%;display: grid;grid-template-columns: 96px 118px;column-gap: 18px;align-items: center;justify-content: center;padding: 0 20px;box-sizing: border-box;"> <!-- 改为60%+居中，适配不同宽度 -->
				<div></div>
				<div style="text-align: center;">发电量</div>
			</div>
		</div>
		<!-- 滚动容器：1. 修复calc空格错误 2. 高度调至230px 3. 优化宽度计算 -->
		<div class="fdxl-scroll-container" style="height: 160px;overflow-y: auto;background-color: #001A33;border: 1px solid #0099FF;border-radius: 4px;margin-left: 20px;width: calc(100% - 40px);margin-top: 5px;">
			<div v-for="(item,index) in fdxlList" style="height: 40px;line-height: 40px;background-color: #001A33;width: 100%;display: flex;font-size: 0.7vw;color: #87CEFA;border-bottom: 2px solid #003C66;" :title="item.deviceName" :key="index">
				<div style="width: 38%;text-align: center;cursor: pointer;padding: 0 14px;box-sizing: border-box;" @click="gotoStationMonitor(item.id)">
					{{item.deviceName ? item.deviceName.substring(0,12) : '--'}}
				</div>
				<div style="width: 62%;display: grid;grid-template-columns: 96px 118px;column-gap: 18px;align-items: center;justify-content: center;padding: 0 20px;box-sizing: border-box;"> <!-- 加居中，优化布局 -->
					<div>
						<div :style="{width:Number(item.blLenght) >= 18 ? Number(item.blLenght)+'px' : '0px',background:'#0099FF',borderRadius:'5px',height:'10px'}" />
					</div>
					<div style="color: #B0E2FF;text-align: center;">
						{{item.powerValue ? item.powerValue : 0}}kwh
					</div>
				</div>
			</div>
		</div>
			</div>
				</div>

			<!-- 中间列：地图+发电量统计图表 -->
			<div class="home-center-column" style="width: 850px;margin-left: 10px;">
				<div class="map-panel" style="height: 412px;border: 1px solid #0099FF;border-radius: 6px;background-color: #002B4D;position: relative;">
					<div class="mobile-map-heading">
						<i class="el-icon-location-information"></i>
						<div>
							<strong>电站分布</strong>
							<span>{{powerStationData.allPowerStation ? powerStationData.allPowerStation : 0}} 座电站</span>
						</div>
					</div>
					<div class="map-search" style="height: 42px;position: absolute;z-index: 99;top: 12px;width: 826px;margin-left: 12px;">
						<el-input placeholder="请输入电站名称搜索" v-model="query.stationName" style="background-color: #001A33;border: 1px solid #0099FF;color: #87CEFA;">
							<i slot="suffix" class="el-input__icon el-icon-search" @click="loadStList();" style="color: #87CEFA;"></i>
						</el-input>
					</div>
					<div>
						<el-amap vid="amap" :zoom="zoom" :center="center" ref="map" class="amap-demo" style="width: 850px;height: 412px;background-color: #001A33;">
							<el-amap-marker
								v-for="(marker,index) in markers"
								:key ="'marker'+index"
								:events="markerEvents"
								:position ="marker.position"
								:label="marker.label"
								:icon="marker.icon"
								:extData="marker.extData">
							</el-amap-marker>
						</el-amap>
					</div>
				</div>
<div class="chart-panel" style="height: 405px;margin-top: 10px;background-color: #002B4D;border: 1px solid #0099FF;border-radius: 6px;overflow: hidden;">
    <!-- 头部栏：核心是flex布局+精准垂直居中 -->
    <div class="chart-header" style="height: 48px;width: 100%;border-bottom: 2px solid #003C66;display: flex;align-items: center;overflow: hidden;">
        <!-- 左侧：图标+标题 整体垂直居中 -->
        <div style="display: flex;align-items: center;height: 100%;">
            <div style="margin-left: 20px;">
                <img src="../../../static/发电量统计(1).png" style="vertical-align: middle;"/>
            </div>
            <div style="color: #87CEFA;font-size: 14px;margin-left: 10px;line-height: 1;">
                发电量统计
            </div>
        </div>

        <!-- 右侧：切换按钮+日期选择器 整体右对齐+垂直居中 -->
        <div class="chart-actions" style="margin-left: auto;margin-right: 20px;display: flex;align-items: center;height: 100%;">
            <div v-for="(item,index) in optTypeList" 
                 :class="optTypeIndex==index?'aaaa1':'aaaa2'"
                 :style="{marginLeft:index>0?'16px':'0px'}" 
                 @click="loadData(index);" 
                 :key="index"
                 style="line-height: 29px;"> <!-- 按钮行高匹配自身高度 -->
                {{item}}
            </div>
            <div style="margin-left: 12px;height: 100%;display: flex;align-items: center;">
                <el-date-picker
                    class="chart-date-range"
                    v-model="value1"
                    size="small"
                    @change="wsss"
                    type="daterange"
                    range-separator="至"
                    popper-class="home-chart-date-popper"
                    style="background-color: #001A33;border: 1px solid #0099FF;color: #87CEFA;height: 29px;line-height: 29px;">
                </el-date-picker>
            </div>
        </div>
    </div>

    <!-- 图表容器：宽度改为100%适配父容器，避免固定宽度错位 -->
    <div class="chart-body" style="width: 100%;height: calc(100% - 48px);padding: 0 1px 1px 1px;box-sizing: border-box;">
        <el-row ref="powerChart" id="homePowerChart" class="chartsBox" style="width: 100%;height: 100%;background-color: #001A33;border-radius: 0 0 5px 5px;" />
    </div>
</div>
			</div>

			<!-- 右侧列：天气 → 电站信息 → 设备工况 -->
			<div class="home-side-column home-right-column" style="width: 384px;margin-left: 10px;">
				<!-- 1. 天气模块（默认广东，日期格式改为MM-DD） -->
				<div style="width: 384px;background-color: #002B4D;height: 230px;border: 1px solid #0099FF;border-radius: 6px;">
					<div style="height: 48px;width: 100%;border-bottom: 2px solid #003C66;display: flex;align-items: center;">
						<div style="margin-left: 20px;margin-top: 0;">
							<img src="../../../static/天气预报(1).png"/>
						</div>
						<div style="color: #87CEFA;font-size: 14px;line-height: 48px;margin-left: 10px;">
							天气预报
						</div>
						<div style="margin-left: auto;margin-right: 10px;line-height: 48px;color: #6699CC;font-size: 12px;">
							更新：{{weather.reporttime ? formatReportTime(weather.reporttime) : '暂无'}}
						</div>
					</div>
					<div style="display: flex;justify-content: space-around;padding: 15px 10px;height: calc(100% - 68px);">
						<div v-for="(item,index) in weather.casts.slice(0,4)" :key="index" style="text-align: center;color: #87CEFA;">
							<!-- 日期格式改为MM-DD -->
							<div style="font-size: 16px;color: #B0E2FF;margin-bottom: 8px;font-weight: bold;">
								{{formatDate(item.date)}}
							</div>
							<div style="font-size: 14px;margin-bottom: 8px;">
								{{item.dayweather ? item.dayweather : '晴'}}
							</div>
							<!-- 修正温度显示（原140改为14.0） -->
							<div style="font-size: 14px;color: #00CCFF;margin-bottom: 8px;">
								{{item.nighttemp_float ? item.nighttemp_float : 0}}/{{item.daytemp_float ? item.daytemp_float : 0}}°C
							</div>
							<div style="font-size: 12px;">
								{{item.daywind ? item.daywind : '无'}}风
							</div>
							<div style="font-size: 12px;">
								{{item.daypower ? item.daypower : 0}}级
							</div>
						</div>
					</div>
				</div>

				<!-- 2. 电站信息模块 -->
				<div style="width: 384px;background-color: #002B4D;height: 298px;margin-top: 20px;border: 1px solid #0099FF;border-radius: 6px;">
					<div style="height: 48px;width: 100%;border-bottom: 2px solid #003C66;display: flex;align-items: center;">
						<div style="margin-left: 20px;margin-top: 0;">
							<img src="../../../static/电站信息(1).png"/>
						</div>
						<div style="color: #87CEFA;font-size: 14px;line-height: 48px;margin-left: 10px;">
							电站信息
						</div>
					</div>
					<div style="display: flex;width: calc(100% - 20px);margin-top: 10px;height: 100px;margin-left: 10px;">
						<div style="width: calc((100% - 10px)/2);background: #001A33;height: 100px;border-radius: 6px;box-shadow: 0px 0px 120px 0px rgba(0,153,255,0.3);border: 1px solid #0099FF;">
							<div style="display: flex;align-items: center;justify-content: center;margin-top: 20px;">
								<div style="margin-top: 0;margin-left: 0;">
									<img src="../../../static/总装机容量 (1).png" style="width: 3.2vh;height: 3.3vh;"/>
								</div>
								<div style="font-size: 16px;margin-top: 0;color: #87CEFA;margin-left: 5px;">
									总装机容量
								</div>
							</div>
							<div style="margin-top: 5px;color: #00CCFF;font-size: 1.2vw;font-weight: bold;text-align: center;">
								{{powerStationData.allCapacity ? powerStationData.allCapacity : 0}} <label style="font-size: 1vw;color: #B0E2FF;">kw</label>
							</div>
						</div>
						<div style="width: calc((100% - 10px)/2);background: #001A33;height: 100px;border-radius: 6px;box-shadow: 0px 0px 120px 0px rgba(0,153,255,0.3);margin-left: 10px;border: 1px solid #0099FF;">
							<div style="display: flex;align-items: center;justify-content: center;margin-top: 20px;">
								<div style="margin-top: 0;margin-left: 0;">
									<img src="../../../static/总电站数量.png" style="width: 3.2vh;height: 3.3vh;"/>
								</div>
								<div style="font-size: 16px;margin-top: 0;color: #87CEFA;margin-left: 5px;">
									总电站数量
								</div>
							</div>
							<div style="margin-top: 5px;color: #00CCFF;font-size: 1.2vw;font-weight: bold;text-align: center;">
								{{powerStationData.allPowerStation ? powerStationData.allPowerStation : 0}} <label style="font-size: 1vw;color: #B0E2FF;">个</label>
							</div>
						</div>
					</div>
					<div style="display: flex;width: calc(100% - 20px);margin-top: 5px;height: 100px;margin-left: 10px;">
						<div style="width: calc((100% - 10px)/2);background: #001A33;height: 100px;border-radius: 6px;box-shadow: 0px 0px 120px 0px rgba(0,153,255,0.3);border: 1px solid #0099FF;">
							<div style="display: flex;align-items: center;justify-content: center;margin-top: 20px;">
								<div style="margin-top: 0;margin-left: 0;">
									<img src="../../../static/二氧化碳减排量 (1).png" style="width: 3.2vh;height: 3.3vh;"/>
								</div>
								<div style="font-size: 16px;margin-top: 0;color: #87CEFA;margin-left: 5px;">
									二氧化碳减排量
								</div>
							</div>
							<div style="margin-top: 5px;color: #00CCFF;font-size: 1.2vw;font-weight: bold;text-align: center;">
								{{powerStationData.eyhtpfl ? powerStationData.eyhtpfl : 0}} <label style="font-size: 1vw;color: #B0E2FF;">kg</label>
							</div>
						</div>
						<div style="width: calc((100% - 10px)/2);background: #001A33;height: 100px;border-radius: 6px;box-shadow: 0px 0px 120px 0px rgba(0,153,255,0.3);margin-left: 10px;border: 1px solid #0099FF;">
							<div style="display: flex;align-items: center;justify-content: center;margin-top: 20px;">
								<div style="margin-top: 0;margin-left: 0;">
									<img src="../../../static/有功功率.png" style="width: 3.2vh;height: 3.3vh;"/>
								</div>
								<div style="font-size: 16px;margin-top: 0;color: #87CEFA;margin-left: 5px;">
									总实时发电功率
								</div>
							</div>
							<div style="margin-top: 5px;color: #00CCFF;font-size: 1.2vw;font-weight: bold;text-align: center;">
								{{formatNumber(powerStationData.zssfdgl, 2)}} <label style="font-size: 1vw;color: #B0E2FF;">kw</label>
							</div>
						</div>
					</div>
				</div>

				<!-- 3. 设备工况模块 -->
				<div style="width: 384px;background-color: #002B4D;height: 257px;margin-top: 20px;border: 1px solid #0099FF;border-radius: 6px;">
					<div style="height: 48px;width: 100%;border-bottom: 2px solid #003C66;display: flex;align-items: center;">
						<div style="margin-left: 20px;margin-top: 0;">
							<img src="../../../static/设备工况(1).png"/>
						</div>
						<div style="color: #87CEFA;font-size: 14px;line-height: 48px;margin-left: 10px;">
							设备工况
						</div>
					</div>
					<div style="display: flex;height: calc(100% - 68px);width: calc(100% - 38px);margin-left: 19px;">
						<div @click="$router.push({path: '/deviceJianCe', query: {deviceStatus: 2}})" style="margin-top: 10px;height: 155px;border-radius: 6px;background-color: #001A33;width: calc((100% - 20px)/3);text-align: center;border: 1px solid #0099FF;cursor: pointer;">
							<div style="margin-top: 10px;color: #87CEFA;font-size: 0.9vw;">正常</div>
							<div style="margin-top: 8px;"><img src="../../../static/在线.png" style="width: 1.6vw;height: 3.4vh;"/></div>
							<div class="device-status-number" style="margin-top: 4px;color: #00CCFF;font-weight: bold;font-size: 1vw;">{{deviceStatusData.normalNum ? deviceStatusData.normalNum : 0}}</div>
							<div class="device-status-unit" style="margin-top: 4px;color: #00CCFF;font-size: 0.8vw;font-weight: bold;">台</div>
						</div>
						<div @click="$router.push({path: '/warnListVue'})" style="margin-top: 10px;height: 155px;margin-left: 10px;background-color: #001A33;width: calc((100% - 20px)/3);text-align: center;border-radius: 6px;border: 1px solid #FF6666;cursor: pointer;">
							<div style="margin-top: 10px;color: #FF8888;font-size: 0.9vw;">告警</div>
							<div style="margin-top: 8px;"><img src="../../../static/告警.png" style="width: 1.6vw;height: 3.4vh;"/></div>
							<div class="device-status-number" style="margin-top: 4px;color: #FF6666;font-weight: bold;font-size: 1vw;">{{deviceStatusData.warnNum ? deviceStatusData.warnNum : 0}}</div>
							<div class="device-status-unit" style="margin-top: 4px;color: #FF6666;font-size: 0.8vw;font-weight: bold;">台</div>
						</div>
						<div @click="$router.push({path: '/deviceJianCe', query: {deviceStatus: 1}})" style="margin-top: 10px;height: 155px;margin-left: 10px;background-color: #001A33;width: calc((100% - 20px)/3);text-align: center;border-radius: 6px;border: 1px solid #666666;cursor: pointer;">
							<div style="margin-top: 10px;color: #999999;font-size: 0.9vw;">离线</div>
							<div style="margin-top: 8px;"><img src="../../../static/离线.png" style="width: 1.6vw;height: 3.4vh;"/></div>
							<div class="device-status-number" style="margin-top: 4px;color: #999999;font-weight: bold;font-size: 1vw;">{{deviceStatusData.offlineNum ? deviceStatusData.offlineNum : 0}}</div>
							<div class="device-status-unit" style="margin-top: 4px;color: #999999;font-size: 0.8vw;font-weight: bold;">台</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 电站详情弹窗（日期格式同步修改） -->
		<el-dialog
		  :title="addFormObject.stationName ? addFormObject.stationName : '电站详情'"
		  :visible.sync="showPowerInfo"
		  :modal="false"
		  @close="showPowerInfo = false;"
		  width="850px"
		  custom-class="dark-dialog station-info-dialog">
		  <div style="display: flex;margin-top: 10px;align-items: center;">
			  <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;color: #87CEFA;">
				  <div style="width: 150px;margin-bottom: 8px;text-align: left;">
					  电站类型：<label v-if="addFormObject.stationType == 1" style="color: #B0E2FF;">基站叠光</label>
					  <label v-if="addFormObject.stationType == 2" style="color: #B0E2FF;">离网电站</label>
					  <label v-else style="color: #B0E2FF;">--</label>
				  </div>
				 <img :src="addFormObject.picUrl ? addFormObject.picUrl : '../../../static/5.png'" style="width: 150px;height: 100px;border: 1px solid #0099FF;border-radius: 4px;"/> 
			  </div>
			  <div style="margin-left: 10px;color: #87CEFA;display: flex;flex-direction: column;justify-content: center;">
				  <div style="display: flex;margin-top: 5px;"><div style="width: 170px;text-align: right;color: #87CEFA;">投资主体：</div><div style="color: #B0E2FF;">{{addFormObject.investBody ? addFormObject.investBody : '--'}}</div></div>
				  <div style="display: flex;margin-top: 5px;"><div style="width: 170px;text-align: right;color: #87CEFA;">负责人：</div><div style="color: #B0E2FF;">{{addFormObject.userName ? addFormObject.userName : '--'}}</div></div>
				  <div style="display: flex;margin-top: 5px;"><div style="width: 170px;text-align: right;color: #87CEFA;">注册时间：</div><div style="color: #B0E2FF;">{{addFormObject.registrationTime ? addFormObject.registrationTime : '--'}}</div></div>
				  <div style="display: flex;margin-top: 5px;"><div style="width: 170px;text-align: right;color: #87CEFA;">设备型号：</div><div style="color: #B0E2FF;">{{addFormObject.deviceModel ? addFormObject.deviceModel : '--'}}</div></div>
				  <div style="display: flex;margin-top: 5px;"><div style="width: 170px;text-align: right;color: #87CEFA;">地理位置：</div><div style="color: #B0E2FF;">{{addFormObject.stationAddress ? addFormObject.stationAddress : '--'}}</div></div>
			  </div>
			  <div style="margin-left: 10px;color: #87CEFA;display: flex;flex-direction: column;justify-content: center;">
				  <div style="display: flex;margin-top: 5px;"><div style="width: 170px;text-align: right;color: #87CEFA;">消纳类型：</div>
					  <div v-if="addFormObject.consumptionType == 1" style="color: #B0E2FF;">全部自用</div>
					  <div v-if="addFormObject.consumptionType == 2" style="color: #B0E2FF;">余额上网</div>
					  <div v-if="addFormObject.consumptionType == 3" style="color: #B0E2FF;">全额上网</div>
					  <div v-else style="color: #B0E2FF;">--</div>
				  </div>
				  <div style="display: flex;margin-top: 5px;"><div style="width: 170px;text-align: right;color: #87CEFA;">联系电话：</div><div style="color: #B0E2FF;">{{addFormObject.linkMobile ? addFormObject.linkMobile : '--'}}</div></div>
				  <div style="display: flex;margin-top: 5px;"><div style="width: 170px;text-align: right;color: #87CEFA;">开通时间：</div><div style="color: #B0E2FF;">{{addFormObject.openTime ? addFormObject.openTime : '--'}}</div></div>
				  <div style="display: flex;margin-top: 5px;"><div style="width: 170px;text-align: right;color: #87CEFA;">装机容量：</div><div style="color: #B0E2FF;">{{addFormObject.installedCapacity ? addFormObject.installedCapacity : 0}} kw</div></div>
			  </div>
		  </div>
		  <div style="height: 2px;background-color: #003C66;margin-top: 12px;"></div>
		  <div style="display: flex;margin-top: 12px;color: #87CEFA;">
			  <div>天气预报</div>
			  <div style="margin-left: auto;margin-right: 10px;color: #B0E2FF;">更新于：{{weather.reporttime ? formatReportTime(weather.reporttime) : '暂无'}}</div>
		  </div>
		  <div style="display: flex;margin-top: 10px;">
			  <div style="margin-top: 10px;height: calc(90% - 0px);border-radius: 6px;background-color: #001A33;width: calc((100% - 30px)/4);text-align: center;color: #87CEFA;border: 1px solid #0099FF;"
			  v-for="(item,index) in weather.casts" :key="index" :style="index>0?'margin-left:10px':''">
			  	<!-- 弹窗日期格式同步改为MM-DD -->
			  	<div style="margin-top: 0.4vh;font-size: 0.9vw;color: #B0E2FF;font-weight: bold;">
			  		{{formatDate(item.date)}}
			  	</div>
			  	<div style="margin-top: 0.3vh;font-size: 0.9vw;color: #87CEFA;">
			  		{{item.dayweather ? item.dayweather : '晴'}}
			  	</div>
			  	<div style="margin-top: 0.3vh;font-size: 0.8vw;color: #00CCFF;">
			  		{{item.nighttemp_float ? item.nighttemp_float : 0}}/{{item.daytemp_float ? item.daytemp_float : 0}}°C
			  	</div>
			  	<div style="margin-top: 0.3vh;font-size: 0.9vw;color: #87CEFA;">
			  		{{item.daywind ? item.daywind : '无'}}风
			  	</div>
			  	<div style="margin-top: 0.3vh;font-size: 0.9vw;color: #87CEFA;">
			  		{{item.daypower ? item.daypower : 0}}级
			  	</div>
			  </div>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	import axios from 'axios'
	export default {
	    data() {
			return {
				myChart: null,
				cityCode:'440100', // 默认广东广州的城市编码
				optstatus:1,
				statusList:[
					{name:"未处理",id:1},
					{name:"已关闭",id:2},
					{name:"处理中",id:3},
					{name:"已完结",id:4},
				],
				weather:{casts:[],reporttime:''},
				addFormObject:{formTitle:''},
				showPowerInfo:false,
				markerEvents:{
					click: a => {
						this.infoView(a.target.De.extData.sId);
						this.showPowerInfo = true;
					}
				},
				powerGenerationData:{},
				incomeData:{},
				powerStationData:{},
				deviceStatusData:{},
				chartData:null,
				value1:[],
				optTypeIndex:0,
				optTypeList:["月","年"],
				query:{stationName:''},
				markers:[],
				stList:[],
				zoom: 15,
				center: [117.970675, 37.38268],
				warnList:[],
				fdxlList:[],
				baseData:{dayPowerGeneration:0},
				scrollTimer: null,
				warnScrollTimer: null,
				scrollStep: 1,
				scrollInterval: 20,
				isManualDate: false
			}
		},
		mounted() {
			this.setDefaultDate();
			this.loadFdxlList();
			this.loadWarnList();
			this.loadStList();
			this.loadData(0);
			this.loadPowerGenerationBaseData();
			this.loadIncomeBaseData();
			this.loadPowerStationBaseData();
			this.loadDeviceStatusBaseData();
			this.loadDefaultGuangdongWeather(); // 页面加载时默认加载广东天气
			window.addEventListener('resize', this.resizeChart);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.resizeChart);
			if (this.myChart) {
				this.myChart.dispose();
				this.myChart = null;
			}
			if (this.scrollTimer) {
				clearInterval(this.scrollTimer);
				this.scrollTimer = null;
			}
			if (this.warnScrollTimer) {
				clearInterval(this.warnScrollTimer);
				this.warnScrollTimer = null;
			}
		},
		methods:{
			formatNumber(value, decimalPlaces) {
				const numberValue = Number(value);
				return Number.isFinite(numberValue) ? numberValue.toFixed(decimalPlaces) : '0.00';
			},
			getPowerChartDom() {
				const chartRef = this.$refs.powerChart;
				if (chartRef && chartRef.$el) return chartRef.$el;
				return chartRef || null;
			},
			resizeChart() {
				if (this.myChart) this.myChart.resize();
			},
			// 日期格式化：将YYYY-MM-DD转为MM-DD
			formatDate(dateStr) {
				if (!dateStr) return '--';
				return dateStr.substring(5, 10); // 截取月份和日期部分
			},
			// 数据更新时间格式化
			formatReportTime(timeStr) {
				if (!timeStr) return '暂无';
				return timeStr.replace(' ', ' '); // 保持原格式，可根据需要调整
			},
			// 加载默认广东天气
			loadDefaultGuangdongWeather() {
				fetch(`https://restapi.amap.com/v3/weather/weatherInfo?city=440100&key=${process.env.VUE_APP_AMAP_WEATHER_KEY}&extensions=all`)
					.then((response) => response.json())
					.then((data) => {
						this.weather.reporttime = data.forecasts[0].reporttime;
						this.weather.casts = data.forecasts[0].casts;
					}).catch(err => {
						this.$Message.error("获取广东天气失败!");
					});
			},
			gotoStationMonitor(stationId) {
			    console.log("首页准备传递的站点ID：", stationId);
			    if (!stationId || isNaN(stationId)) {
			      this.$Message.warning("站点ID无效，无法跳转！");
			      return;
			    }
			    this.$router.push({
			      path: '/powerAnaly', 
			      query: { stationId: stationId } 
			    });
			    setTimeout(() => {
			      console.log("跳转后路由参数：", this.$router.currentRoute.query);
			    }, 200);
			},
			setDefaultDate() {
				if (this.isManualDate) return;
				const now = new Date();
				if (this.optTypeIndex === 1) {
					const year = now.getFullYear();
					this.value1 = [new Date(year, 0, 1), new Date(year, 11, 31)];
				} else {
					const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
					const endOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
					this.value1 = [startOfMonth, endOfToday];
				}
			},
			wsss(e){
				this.value1 = e;
				this.isManualDate = true;
				this.loadData(this.optTypeIndex);
			},
			closePopover(i) {
			  this.$refs["popover" + i][0].showPopper = false;
			},
			subStatusChange(item){
				let sub = {id:item.id,dealStatus:this.optstatus};
				this.$request.post('/api/index/set/alarm/status',sub).then(response => {
					if(response.data.result){
						this.loadWarnList();
						Object.keys(this.$refs).forEach(ref => {
							if(ref.includes('popover')){
								this.$refs[ref][0].showPopper = false;
							}
						});
					}else{
						this.$Message.error("获取数据失败,请联系管理员!");
					}
				}).catch(err => {
					this.$Message.error("状态修改失败,请联系管理员!");
				})	
			},
			getCityCode() {
				const geocoder = new AMap.Geocoder({
					radius: 1000,
					extensions: 'base'
				});
				let this_ = this;
				geocoder.getAddress([this_.addFormObject.longitude, this_.addFormObject.latitude], (status, result) => {
					if (status === 'complete' && result.regeocode) {
						const addressComponent = result.regeocode.addressComponent;
						fetch(`https://restapi.amap.com/v3/weather/weatherInfo?city=${addressComponent.adcode}&key=${process.env.VUE_APP_AMAP_WEATHER_KEY}&extensions=all`)
							.then((response) => response.json())
							.then((data) => {
								this_.weather.reporttime = data.forecasts[0].reporttime;
								this_.weather.casts = data.forecasts[0].casts;
							}).catch(err => {
								this_.$Message.error("获取天气失败!");
							});
					}
				});
			},
			infoView(id){
				this.$request.get('/api/power/station/info/'+id).then(response => {
					if(response.data.result){
						this.addFormObject = response.data.data;
						this.getCityCode();
					}else{
						this.$Message.error("获取数据失败,请联系管理员!");
					}
				}).catch(err => {
					this.$Message.error("获取电站详情失败,请联系管理员!");
				})	
			},
			initCharts(o) {
				const chartDom = this.getPowerChartDom();
				if (!chartDom) return;
				const myChart = echarts.getInstanceByDom(chartDom) || echarts.init(chartDom);
				this.myChart = myChart;
				var option = {
					title: {
						text: 'kwh',
						subtext: '',
						top: 35,
						left: 49,
						textStyle: {
							color: '#87CEFA',
							fontSize: 14,
							fontWeight: 'bold'
						},
						subtextStyle: {color: '#B0E2FF'}
					},
					xAxis: {
						data: o.times,
						axisLabel: {
							inside: false,
							color: '#87CEFA',
							show: true,
							interval: 0,
							rotate: 45,
							margin: 10,
							fontSize: 12
						},
						axisTick: {show: false},
						axisLine: {
							show: true,
							lineStyle: {color: '#003C66'}
						},
						z: 10,
						splitLine: {lineStyle: {color: '#003C66'}}
					},
					yAxis: {
						axisLine: {
							show: true,
							lineStyle: {color: '#003C66'}
						},
						axisTick: {show: false},
						axisLabel: {color: '#87CEFA', fontSize: 12},
						splitLine: {lineStyle: {color: '#003C66'}}
					},
					dataZoom: [
						{
							type: 'inside',
							start: 0,
							end: 100
						}
					],
					series: [
						{
							type: 'bar',
							barMaxWidth: '40',
							showBackground: false,
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{ offset: 0, color: '#00CCFF' },
									{ offset: 0.5, color: '#0099FF' },
									{ offset: 1, color: '#0066CC' }
								])
							},
							label: {
								normal: {
									show: true,
									position: 'top',
									color: '#B0E2FF',
									fontSize: 11
								}
							},
							data: o.values
						}
					],
					grid: {
						left: 52,
						right: 52,
						bottom: 34,
						top: 86,
						containLabel: true
					}
				};
				myChart.setOption(option, true);
				this.$nextTick(this.resizeChart);
			},
			loadData(i) {
			  this.optTypeIndex = i;
			  this.query.optType = (i + 1);
			  this.setDefaultDate();
			  this.query.startTime = this.value1[0];
			  this.query.endTime = this.value1[1];

			  this.$request.post('/api/index/power/chart/data', this.query).then(response => {
			    if (response.data.result && response.data.data) {
			      const chartData = response.data.data;
			      if (this.optTypeIndex === 1) {
			        chartData.times = chartData.times.map(dateStr => {
			          const [year, month] = dateStr.split('-');
			          return parseInt(month) + '月';
			        });
			      } else {
			        chartData.times = chartData.times.map(dateStr => {
			          const [year, month, day] = dateStr.split('-');
			          return month + '-' + day;
			        });
			      }
			      chartData.times = chartData.times.reverse();
			      chartData.values = chartData.values.reverse();
			      this.initCharts(chartData);
			    }
			  }).catch(err => {
			    this.$Message.error("获取发电量统计数据失败,请联系管理员!");
			    console.error('发电量统计接口异常：', err);
			  })
			},
			loadStList(){
				this.markers = [];
				this.$request.post('/api/index/power/list/data',this.query).then(response => {
					if(response.data.result && response.data.data){
						this.stList = response.data.data;
						if(this.stList.length > 0){
							this.center = [Number(this.stList[0].longitude), Number(this.stList[0].latitude)];
							this.stList.forEach((item,i) => {
								let markerItem = {
									label: {
										offset: [10, -35],
										style: {
											color: "#B0E2FF",
											fontSize: "12px",
											backgroundColor: "rgba(0,43,77,0.9)",
											padding: "2px 6px",
											borderRadius: "3px",
											border: "1px solid #0099FF"
										}
									},
									position: [Number(item.longitude), Number(item.latitude)],
									icon: require("../../../static/19.png"),
									extData: {"sId": item.id}
								};
								this.markers.push(markerItem);
							})
							this.$forceUpdate();
						}
					}
				}).catch(err => {
					this.$Message.error("加载电站点位失败，请检查接口");
					console.error('电站点位接口异常：', err);
				})
			},
			loadWarnList(){
				this.$request.get('/api/index/power/warn/data').then(response => {
					if(response.data.result && response.data.data){
						this.warnList = response.data.data;
						this.$nextTick(() => {
							this.initWarnAutoScroll();
						});
					}
				}).catch(err => {
					this.$Message.error("获取告警列表失败,请联系管理员!");
				})
			},
			loadFdxlList(){
				this.$request.get('/api/index/power/generation/data').then(response => {
					if(response.data.result && response.data.data){
						this.fdxlList = response.data.data;
						this.$nextTick(() => {
							this.initAutoScroll();
						});
					}
				}).catch(err => {
					this.$Message.error("获取发电效益数据失败,请联系管理员!");
				})
			},
			initAutoScroll() {
				const scrollContainer = this.$el.querySelector('.fdxl-scroll-container');
				if (!scrollContainer || this.fdxlList.length === 0) return;
				
				if (this.scrollTimer) {
					clearInterval(this.scrollTimer);
				}

				scrollContainer.addEventListener('mouseenter', () => {
					if (this.scrollTimer) {
						clearInterval(this.scrollTimer);
					}
				});

				scrollContainer.addEventListener('mouseleave', () => {
					this.startScroll();
				});

				this.startScroll();
			},
			startScroll() {
				const scrollContainer = this.$el.querySelector('.fdxl-scroll-container');
				if (!scrollContainer) return;

				this.scrollTimer = setInterval(() => {
					if (scrollContainer.scrollTop >= scrollContainer.scrollHeight - scrollContainer.clientHeight) {
						scrollContainer.scrollTop = 0;
					} else {
						scrollContainer.scrollTop += this.scrollStep;
					}
				}, this.scrollInterval);
			},
			initWarnAutoScroll() {
				const scrollContainer = this.$el.querySelector('.warn-scroll-container');
				if (!scrollContainer || this.warnList.length === 0) return;
				
				if (this.warnScrollTimer) {
					clearInterval(this.warnScrollTimer);
				}

				scrollContainer.addEventListener('mouseenter', () => {
					if (this.warnScrollTimer) {
						clearInterval(this.warnScrollTimer);
					}
				});

				scrollContainer.addEventListener('mouseleave', () => {
					this.startWarnScroll();
				});

				this.startWarnScroll();
			},
			startWarnScroll() {
				const scrollContainer = this.$el.querySelector('.warn-scroll-container');
				if (!scrollContainer) return;

				this.warnScrollTimer = setInterval(() => {
					if (scrollContainer.scrollTop >= scrollContainer.scrollHeight - scrollContainer.clientHeight) {
						scrollContainer.scrollTop = 0;
					} else {
						scrollContainer.scrollTop += this.scrollStep;
					}
				}, this.scrollInterval);
			},
			loadPowerGenerationBaseData(){
				this.$request.get('/api/index/base/power-generation/data').then(response => {
					if(response.data.result && response.data.data){
						this.powerGenerationData = response.data.data;
					}
				}).catch(err => {
					this.$Message.error('获取发电数据失败,请联系管理员!');
				})
			},
			loadIncomeBaseData(){
				this.$request.get('/api/index/base/income/data').then(response => {
					if(response.data.result && response.data.data){
						this.incomeData = response.data.data;
					}
				}).catch(err => {
					this.$Message.error('获取经济收益失败,请联系管理员!');
				})
			},
			loadPowerStationBaseData(){
				this.$request.get('/api/index/base/power-station/data').then(response => {
					if(response.data.result && response.data.data){
						this.powerStationData = response.data.data;
					}
				}).catch(err => {
					this.$Message.error('获取电站信息失败,请联系管理员!');
				})
			},
			loadDeviceStatusBaseData(){
				this.$request.get('/api/index/base/device-status/data').then(response => {
					if(response.data.result && response.data.data){
						this.deviceStatusData = response.data.data;
					}
				}).catch(err => {
					this.$Message.error('获取设备工况失败,请联系管理员!');
				})
			}
		}
	}
</script>

<style>
	.home-chart-date-popper.el-picker-panel,
	.home-chart-date-popper .el-picker-panel,
	.home-chart-date-popper .el-date-range-picker{
		border-color: #003567 !important;
		background-color: #002B4D !important;
		color: #87CEFA !important;
		box-shadow: 0 12px 32px rgba(0, 10, 24, 0.45) !important;
	}
	.home-chart-date-popper .el-picker-panel__body,
	.home-chart-date-popper .el-date-range-picker__content{
		background-color: #002B4D !important;
	}
	.home-chart-date-popper .el-date-range-picker__content.is-left{
		border-right-color: #003567 !important;
	}
	.home-chart-date-popper .el-date-table th,
	.home-chart-date-popper .el-picker-panel__icon-btn,
	.home-chart-date-popper .el-date-range-picker__header,
	.home-chart-date-popper .el-date-range-picker__content .el-date-range-picker__header div{
		color: #B0E2FF !important;
	}
	.home-chart-date-popper .el-date-table th{
		border-bottom-color: #003567 !important;
	}
	.home-chart-date-popper .el-date-table td{
		color: #87CEFA !important;
	}
	.home-chart-date-popper .el-date-table td.next-month,
	.home-chart-date-popper .el-date-table td.prev-month{
		color: #3D6585 !important;
	}
	.home-chart-date-popper .el-date-table td.available:hover{
		color: #00CCFF !important;
	}
	.home-chart-date-popper .el-date-table td.in-range div,
	.home-chart-date-popper .el-date-table td.in-range div:hover{
		background-color: rgba(0, 153, 255, 0.18) !important;
	}
	.home-chart-date-popper .el-date-table td.today span{
		color: #00CCFF !important;
		font-weight: 600;
	}
	.home-chart-date-popper .el-date-table td.current:not(.disabled) span,
	.home-chart-date-popper .el-date-table td.start-date span,
	.home-chart-date-popper .el-date-table td.end-date span{
		background-color: #0099FF !important;
		color: #002B4D !important;
	}
	.home-chart-date-popper .el-date-table td.disabled div{
		background-color: #001A33 !important;
		color: #3D6585 !important;
	}
	.home-chart-date-popper .el-picker-panel__footer{
		border-top-color: #003567 !important;
		background-color: #002B4D !important;
	}
	.home-chart-date-popper .el-picker-panel__footer .el-button{
		min-width: 54px;
		padding-left: 12px;
		padding-right: 12px;
	}
	.home-chart-date-popper .el-button--text{
		color: #00CCFF !important;
	}
	.home-chart-date-popper .el-button--default{
		border-color: #0076B8 !important;
		background-color: #001A33 !important;
		color: #87CEFA !important;
	}
	.home-chart-date-popper .el-button--primary{
		border-color: #0099FF !important;
		background-color: #0099FF !important;
		color: #002B4D !important;
	}
	.home-chart-date-popper[x-placement^="bottom"] .popper__arrow,
	.home-chart-date-popper[x-placement^="bottom"] .popper__arrow::after{
		border-bottom-color: #002B4D !important;
	}
	.home-chart-date-popper[x-placement^="top"] .popper__arrow,
	.home-chart-date-popper[x-placement^="top"] .popper__arrow::after{
		border-top-color: #002B4D !important;
	}
	@media screen and (max-width: 760px) {
		.home-chart-date-popper.el-date-range-picker {
			left: 8px !important;
			width: calc(100vw - 16px) !important;
		}
		.home-chart-date-popper .el-picker-panel__body {
			min-width: 0 !important;
		}
		.home-chart-date-popper .el-date-range-picker__content {
			width: 100% !important;
		}
		.home-chart-date-popper .el-date-range-picker__content.is-right {
			display: none;
		}
	}
</style>

<style scoped>
	.home-page /deep/ .el-dialog__wrapper {
		pointer-events: none;
		background: transparent !important;
	}
	.home-page /deep/ .station-info-dialog {
		pointer-events: auto;
		margin-top: 70px !important;
		background-color: #002B4D;
		border: 1px solid #0099FF;
		position: relative;
		box-shadow:
			0 12px 36px rgba(0, 10, 24, 0.45),
			inset 0 0 0 1px rgba(0, 204, 255, 0.18),
			inset 0 0 22px rgba(0, 153, 255, 0.08);
	}
	.home-page /deep/ .station-info-dialog::before {
		content: "";
		position: absolute;
		inset: -1px;
		border-radius: inherit;
		pointer-events: none;
		z-index: 2;
		background:
			linear-gradient(#00CCFF, #00CCFF) left top / 24px 2px no-repeat,
			linear-gradient(#00CCFF, #00CCFF) left top / 2px 24px no-repeat,
			linear-gradient(#00CCFF, #00CCFF) right top / 24px 2px no-repeat,
			linear-gradient(#00CCFF, #00CCFF) right top / 2px 24px no-repeat,
			linear-gradient(#00CCFF, #00CCFF) left bottom / 24px 2px no-repeat,
			linear-gradient(#00CCFF, #00CCFF) left bottom / 2px 24px no-repeat,
			linear-gradient(#00CCFF, #00CCFF) right bottom / 24px 2px no-repeat,
			linear-gradient(#00CCFF, #00CCFF) right bottom / 2px 24px no-repeat;
		filter: drop-shadow(0 0 5px rgba(0, 204, 255, 0.55));
	}
	.home-page /deep/ .station-info-dialog .el-dialog__header {
		background-color: #002B4D;
		border-bottom: 1px solid #003C66;
	}
	.home-page /deep/ .station-info-dialog .el-dialog__title,
	.home-page /deep/ .station-info-dialog .el-dialog__close {
		color: #87CEFA !important;
	}
	.home-page /deep/ .station-info-dialog .el-dialog__body {
		background-color: #002B4D;
	}
	.dark-dialog .el-dialog__header {
		background-color: #002B4D;
		border-bottom: 1px solid #003C66;
	}
	.dark-dialog .el-dialog__title {
		color: #87CEFA !important;
	}
	.dark-dialog .el-dialog__close {
		color: #87CEFA !important;
	}
	.el-date-picker__header, .el-picker-panel__body {
		background-color: #002B4D !important;
		color: #87CEFA !important;
		border-color: #003C66 !important;
	}
	.el-date-table td {
		color: #87CEFA !important;
	}
	.el-date-table td.today {
		color: #00CCFF !important;
	}
	.el-date-table td.active {
		background-color: #0099FF !important;
		color: #001A33 !important;
	}
	.el-select-dropdown {
		background-color: #002B4D !important;
		border: 1px solid #0099FF !important;
	}
	.el-select-dropdown__item {
		color: #87CEFA !important;
	}
	.el-select-dropdown__item:hover {
		background-color: #003C66 !important;
	}
	.el-select-dropdown__item.selected {
		color: #00CCFF !important;
		background-color: #003C66 !important;
	}
	.el-input__inner {
		background-color: #001A33 !important;
		border: 1px solid #0099FF !important;
		color: #87CEFA !important;
	}
	.el-button {
		background-color: #002B4D !important;
		border: 1px solid #0099FF !important;
		color: #87CEFA !important;
	}
	.el-button--primary {
		background-color: #0099FF !important;
		border: none !important;
		color: #fff !important;
	}
	.aaaa2{
		width: 54px;
		height: 29px;
		background: #001A33;
		border-radius: 4px;
		border: 1px solid #0099FF;
		cursor: pointer;
		line-height: 29px;
		text-align: center;
		color: #87CEFA;
	}
	.aaaa1{
		width: 54px;
		height: 29px;
		background: #0099FF;
		border-radius: 4px;
		cursor: pointer;
		line-height: 29px;
		text-align: center;
		color: #001A33;
		font-weight: bold;
	}
	.aaaaaa{
		margin-left: 10px;
	}
	.fdxl-table-header {
		border-radius: 4px 4px 0 0 !important;
		border-bottom-color: #003C66 !important;
	}
	.fdxl-scroll-container {
		scrollbar-width: none;
		-ms-overflow-style: none;
		overflow-x: hidden !important;
		margin-top: 0 !important;
		border-top: none !important;
		border-radius: 0 0 4px 4px !important;
	}
	.fdxl-scroll-container::-webkit-scrollbar {
		display: none;
	}
	.fdxl-scroll-container > div {
		box-sizing: border-box;
		min-width: 0;
		overflow: hidden;
	}
	.fdxl-scroll-container > div > div {
		box-sizing: border-box;
		min-width: 0;
	}
	.fdxl-scroll-container > div > div:first-child {
		overflow: hidden;
		padding: 0 8px;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.fdxl-scroll-container > div > div:nth-child(2) {
		min-width: 0;
		overflow: hidden;
	}
	.fdxl-scroll-container > div > div:nth-child(2) > div:first-child {
		flex: 0 0 96px;
		max-width: 96px;
		min-width: 36px;
		overflow: hidden;
	}
	.fdxl-scroll-container > div > div:nth-child(2) > div:first-child > div {
		max-width: 100% !important;
	}
	.fdxl-scroll-container > div > div:nth-child(2) > div:last-child {
		flex: 0 0 118px;
		min-width: 92px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
		background-color: #001A33;
	}
	::-webkit-scrollbar-thumb {
		background-color: #0099FF;
		border-radius: 3px;
	}
	::-webkit-scrollbar-track {
		background-color: #002B4D;
		border-radius: 3px;
	}
	.el-date-editor--daterange, .el-date-editor--monthrange {
		display: flex !important;
		align-items: center !important;
		padding: 0 !important;
		border-radius: 0 !important;
	}
	.el-date-editor--daterange .el-range-icon, .el-date-editor--monthrange .el-range-icon {
		color: #ffffff !important;
		margin: 0 8px !important;
		line-height: 38px !important;
	}
	.el-date-editor--daterange .el-range-separator, .el-date-editor--monthrange .el-range-separator {
		color: #ffffff !important;
		width: 24px !important;
		text-align: center !important;
		padding: 0 !important;
		margin: 0 !important;
		line-height: 38px !important;
	}
	.el-date-editor--daterange input, .el-date-editor--monthrange input {
		background-color: transparent !important;
		border: none !important;
		color: #87CEFA !important;
		height: 36px !important;
		line-height: 36px !important;
		text-align: center !important;
		flex: 1 !important;
		padding: 0 !important;
	}
	.el-date-editor--daterange input::placeholder, .el-date-editor--monthrange input::placeholder {
		color: #87CEFA80 !important;
	}
	.home-page * {
		box-sizing: border-box;
	}
	.home-page {
		font-family: "HarmonyOS Sans SC", "Microsoft YaHei UI", "Microsoft YaHei", "PingFang SC", Arial, sans-serif;
		background:
			radial-gradient(circle at 50% 0%, rgba(0, 153, 255, 0.16), transparent 34%),
			linear-gradient(180deg, #001A33 0%, #001326 100%) !important;
	}
	.home-dashboard {
		align-items: stretch !important;
	}
	.home-side-column > div,
	.map-panel,
	.chart-panel {
		border-color: rgba(0, 153, 255, 0.9) !important;
		box-shadow: 0 10px 28px rgba(0, 10, 24, 0.34), inset 0 0 22px rgba(0, 153, 255, 0.08);
		overflow: hidden;
		position: relative;
	}
	.home-side-column > div::before,
	.map-panel::before,
	.chart-panel::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 1px;
		background: linear-gradient(90deg, transparent, rgba(176, 226, 255, 0.72), transparent);
		pointer-events: none;
		z-index: 1;
	}
	.panel-header,
	.home-side-column > div > div:first-child,
	.chart-header {
		background: linear-gradient(90deg, rgba(0, 60, 102, 0.55), rgba(0, 43, 77, 0.18)) !important;
	}
	.panel-title-icon,
	.home-side-column > div > div:first-child > div:first-child {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 28px;
		height: 100%;
	}
	.panel-title-icon img,
	.home-side-column > div > div:first-child img,
	.chart-header img {
		display: block;
		object-fit: contain;
	}
	.panel-title,
	.home-side-column > div > div:first-child > div:nth-child(2),
	.chart-header > div:first-child > div:nth-child(2) {
		font-weight: 600;
		letter-spacing: 0;
		text-shadow: 0 0 12px rgba(0, 204, 255, 0.32);
	}
	.power-data-grid {
		display: flex;
		align-items: stretch;
		justify-content: center;
		gap: 10px;
		height: calc(100% - 48px);
		margin-top: 10px;
	}
	.power-data-panel {
		height: 240px !important;
	}
	.income-panel {
		height: 240px !important;
	}
	.power-data-card {
		flex: 1 1 0;
		min-width: 0;
		height: 167px !important;
		align-self: center;
		margin-top: 0 !important;
		margin-left: 0 !important;
		text-align: center;
	}
	.metric-card {
		border-color: rgba(0, 153, 255, 0.85) !important;
		box-shadow: inset 0 0 16px rgba(0, 153, 255, 0.1), 0 6px 16px rgba(0, 10, 24, 0.18);
		transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
	}
	.metric-card:hover {
		border-color: #00CCFF !important;
		box-shadow: inset 0 0 20px rgba(0, 204, 255, 0.16), 0 8px 18px rgba(0, 10, 24, 0.25);
		transform: translateY(-1px);
	}
	.power-data-grid .metric-card,
	.income-grid .metric-card {
		border-radius: 6px !important;
		display: grid !important;
		grid-template-rows: 20px 42px 24px;
		align-content: space-between;
		justify-items: center;
		row-gap: 0;
		height: 164px !important;
		padding: 14px 10px !important;
		text-align: center;
	}
	.power-data-grid .metric-card > div:first-child,
	.income-grid .metric-card > div:first-child {
		width: 100%;
		margin: 0 !important;
		color: #87CEFA !important;
		font-family: "HarmonyOS Sans SC", "Microsoft YaHei UI", "Microsoft YaHei", "PingFang SC", Arial, sans-serif;
		font-size: 14px !important;
		font-weight: 500;
		line-height: 20px !important;
		white-space: nowrap;
		text-shadow: none;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.power-data-grid .metric-card > div:nth-child(2),
	.income-grid .metric-card > div:nth-child(2) {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 42px;
		margin: 0 !important;
	}
	.power-data-grid .metric-card > div:nth-child(2) img,
	.income-grid .metric-card > div:nth-child(2) img {
		width: 36px !important;
		height: 36px !important;
		object-fit: contain;
	}
	.power-data-grid .metric-card > div:nth-child(3),
	.income-grid .metric-card > div:nth-child(3) {
		width: 100%;
		margin: 0 !important;
		color: #00CCFF !important;
		font-family: "Bahnschrift", "DIN Alternate", "DINAlternate", "Microsoft YaHei UI", "Microsoft YaHei", sans-serif;
		font-size: 16px !important;
		font-weight: 700 !important;
		line-height: 24px !important;
		text-align: center;
		white-space: normal;
		word-break: break-word;
		text-shadow: 0 0 10px rgba(0, 204, 255, 0.28);
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.power-data-grid .metric-card > div:nth-child(3) span,
	.income-grid .metric-card > div:nth-child(3) .income-value-unit {
		color: inherit;
		font-family: inherit;
		font-size: inherit;
		font-weight: inherit;
		margin-left: 2px;
	}
	.income-grid .metric-card > div:nth-child(3) {
		flex-direction: column;
		white-space: normal;
		word-break: keep-all;
	}
	.income-grid .metric-card > div:nth-child(3) .income-value-unit {
		display: block;
		margin-top: 2px;
		margin-left: 0;
	}
	.metric-label {
		width: 100%;
		margin: 0 !important;
		line-height: 18px !important;
		font-size: 13px !important;
		font-weight: 400;
		white-space: nowrap;
	}
	.metric-icon {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 42px;
		margin: 0 !important;
	}
	.metric-icon img {
		width: 36px !important;
		height: 36px !important;
		object-fit: contain;
	}
	.metric-value {
		width: 100%;
		margin: 0 !important;
		line-height: 20px !important;
		color: #00CCFF !important;
		font-size: 15px !important;
		text-align: center;
		white-space: normal;
		word-break: break-word;
	}
	.income-grid {
		justify-content: center;
		gap: 10px;
		width: calc(100% - 38px);
		margin-left: 19px !important;
	}
	.income-grid .metric-card {
		flex: 1 1 0;
		align-self: center;
		margin-left: 0 !important;
		margin-top: 0 !important;
	}
	.income-grid .metric-card > div {
		margin-top: 0 !important;
	}
	.home-right-column > div:nth-child(2) > div:not(:first-child) > div,
	.home-right-column > div:nth-child(3) > div:not(:first-child) > div {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.home-right-column > div:nth-child(2) > div:not(:first-child) > div > div:first-child,
	.home-right-column > div:nth-child(3) > div:not(:first-child) > div > div:first-child {
		margin-top: 0 !important;
	}
	.fdxl-table-header,
	.fdxl-scroll-container {
		box-shadow: inset 0 0 14px rgba(0, 153, 255, 0.08);
	}
	.aaaa1,
	.aaaa2 {
		transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
	}
	.aaaa1 {
		box-shadow: 0 0 12px rgba(0, 153, 255, 0.42);
	}
	.aaaa2:hover {
		color: #B0E2FF;
		box-shadow: inset 0 0 12px rgba(0, 153, 255, 0.18);
	}
	.power-data-grid,
	.income-grid,
	.home-right-column > div:first-child > div:nth-child(2),
	.home-right-column > div:nth-child(2) > div:nth-child(2),
	.home-right-column > div:nth-child(2) > div:nth-child(3),
	.home-right-column > div:nth-child(3) > div:nth-child(2) {
		width: 100% !important;
		margin: 0 !important;
		padding: 14px 18px !important;
	}
	.power-data-grid,
	.income-grid {
		padding-top: 14px !important;
		padding-bottom: 14px !important;
	}
	.power-data-grid,
	.income-grid {
		align-items: center !important;
	}
	.income-grid {
		height: calc(100% - 48px) !important;
	}
	.power-data-grid {
		height: calc(100% - 48px) !important;
	}
	.home-right-column > div:first-child > div:nth-child(2) {
		height: calc(100% - 48px) !important;
		align-items: center !important;
		justify-content: space-between !important;
	}
	.home-right-column > div:first-child > div:nth-child(2) > div {
		display: flex;
		flex: 1 1 0;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		min-width: 0;
		height: 100%;
	}
	.home-right-column > div:first-child > div:nth-child(2) > div > div {
		margin-top: 0 !important;
		margin-bottom: 6px !important;
	}
	.home-right-column > div:first-child > div:nth-child(2) > div > div:last-child {
		margin-bottom: 0 !important;
	}
	.home-right-column > div:nth-child(2) > div:nth-child(2),
	.home-right-column > div:nth-child(2) > div:nth-child(3) {
		height: calc((100% - 48px) / 2) !important;
		align-items: center !important;
		gap: 10px;
	}
	.home-right-column > div:nth-child(2) > div:nth-child(2) > div,
	.home-right-column > div:nth-child(2) > div:nth-child(3) > div {
		flex: 1 1 0 !important;
		width: auto !important;
		height: 100% !important;
		margin: 0 !important;
	}
	.home-right-column > div:nth-child(2) > div:not(:first-child) > div > div + div,
	.home-right-column > div:nth-child(3) > div:not(:first-child) > div > div + div {
		margin-top: 8px !important;
	}
	.home-right-column > div:nth-child(3) > div:nth-child(2) {
		height: calc(100% - 48px) !important;
		align-items: center !important;
		gap: 10px;
	}
	.home-right-column > div:nth-child(3) > div:nth-child(2) > div {
		flex: 1 1 0 !important;
		width: auto !important;
		height: 155px !important;
		margin: 0 !important;
	}
	.home-left-column > div:nth-child(3) {
		display: flex;
		flex-direction: column;
		height: 310px !important;
	}
	.home-left-column > div:nth-child(3) > .fdxl-table-header {
		margin: 22px 18px 0 !important;
		width: calc(100% - 36px) !important;
	}
	.home-left-column > div:nth-child(3) > .fdxl-scroll-container {
		width: calc(100% - 36px) !important;
		height: 183px !important;
		margin: 0 18px !important;
	}
	.home-page {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 859px !important;
		min-height: 859px;
		padding: 0 16px;
		box-sizing: border-box;
		overflow: auto !important;
	}
	.home-dashboard {
		display: flex;
		align-items: stretch;
		justify-content: center;
		gap: clamp(10px, 0.8vw, 18px);
		width: 100% !important;
		height: auto !important;
		min-height: 0;
		margin: auto !important;
		flex-shrink: 0;
	}
	.home-side-column {
		flex: 0 0 clamp(320px, 22%, 460px);
		min-width: 0;
	}
	.home-left-column {
		margin-left: 0;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	.home-left-column > div {
		margin-top: 0 !important;
	}
	.home-right-column {
		margin-left: 0 !important;
	}
	.home-side-column > div {
		width: 100% !important;
		box-sizing: border-box;
	}
	.home-center-column {
		flex: 1 1 640px;
		min-width: 520px;
		margin-left: 0 !important;
	}
	.map-panel,
	.chart-panel {
		width: 100%;
		box-sizing: border-box;
	}
	.map-panel > div:not(.map-search) {
		width: 100%;
		height: 100%;
	}
	.map-search {
		left: 12px;
		right: 12px;
		width: auto !important;
		margin-left: 0 !important;
	}
	.amap-demo {
		width: 100% !important;
		height: 100% !important;
	}
	.chart-header {
		gap: 12px;
	}
	.chart-body {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.chartsBox {
		flex: 1 1 auto;
		min-width: 0;
		min-height: 0;
	}
	.chart-actions {
		min-width: 0;
		flex-wrap: wrap;
		justify-content: flex-end;
		row-gap: 6px;
	}
	.chart-actions .el-date-editor--daterange {
		width: min(330px, 28vw) !important;
	}
	.home-page > .home-dashboard {
		max-height: 100%;
	}
	.fdxl-scroll-container > div {
		font-size: 12px !important;
	}
	.home-side-column img[style*="vw"],
	.home-side-column img[style*="vh"] {
		max-width: 42px;
		max-height: 44px;
		min-width: 22px;
		min-height: 22px;
		object-fit: contain;
	}

	@media screen and (min-width: 2100px) {
		.home-page {
			padding-right: 24px;
			padding-left: 24px;
		}
		.home-dashboard {
			gap: 20px;
		}
		.power-data-grid,
		.income-grid,
		.home-right-column > div:first-child > div:nth-child(2),
		.home-right-column > div:nth-child(2) > div:nth-child(2),
		.home-right-column > div:nth-child(2) > div:nth-child(3),
		.home-right-column > div:nth-child(3) > div:nth-child(2) {
			padding-right: 22px !important;
			padding-left: 22px !important;
		}
		.power-data-grid,
		.income-grid,
		.home-right-column > div:nth-child(2) > div:nth-child(2),
		.home-right-column > div:nth-child(2) > div:nth-child(3),
		.home-right-column > div:nth-child(3) > div:nth-child(2) {
			gap: 14px;
		}
		.power-data-grid .metric-card,
		.income-grid .metric-card {
			padding-right: 14px !important;
			padding-left: 14px !important;
		}
	}

	@media screen and (max-width: 1300px) {
		.chart-header {
			height: 64px !important;
		}
		.chart-panel > div:last-child {
			height: calc(100% - 64px) !important;
		}
	}

	@media screen and (max-width: 1180px) {
		.home-page {
			align-items: flex-start;
			justify-content: flex-start;
			padding: 10px;
		}
		.home-dashboard {
			width: 1180px !important;
			min-height: auto;
		}
		.home-side-column {
			flex-basis: 320px;
		}
		.home-center-column {
			min-width: 520px;
		}
	}

	.home-page {
		position: relative;
		isolation: isolate;
		color: #B0E2FF;
		background:
			radial-gradient(circle at 50% 8%, rgba(0, 204, 255, 0.14), transparent 30%),
			radial-gradient(circle at 14% 36%, rgba(0, 153, 255, 0.12), transparent 24%),
			linear-gradient(180deg, #001A33 0%, #001629 52%, #001123 100%) !important;
	}
	.home-page::before {
		content: "";
		position: absolute;
		inset: 0;
		z-index: 0;
		pointer-events: none;
		background-image:
			linear-gradient(rgba(0, 153, 255, 0.06) 1px, transparent 1px),
			linear-gradient(90deg, rgba(0, 153, 255, 0.06) 1px, transparent 1px),
			linear-gradient(180deg, transparent 0%, rgba(0, 204, 255, 0.04) 50%, transparent 100%);
		background-size: 42px 42px, 42px 42px, 100% 7px;
		opacity: 0.7;
	}
	.home-dashboard {
		position: relative;
		z-index: 1;
	}
	.dashboard-panel,
	.home-left-column > div:nth-child(3),
	.home-right-column > div,
	.map-panel,
	.chart-panel {
		background:
			linear-gradient(180deg, rgba(0, 58, 101, 0.92), rgba(0, 34, 62, 0.94)),
			linear-gradient(135deg, rgba(0, 204, 255, 0.13), transparent 36%) !important;
		border: 1px solid rgba(0, 153, 255, 0.62) !important;
		border-radius: 8px !important;
		box-shadow:
			0 16px 34px rgba(0, 8, 22, 0.34),
			inset 0 1px 0 rgba(176, 226, 255, 0.18),
			inset 0 0 24px rgba(0, 153, 255, 0.09);
	}
	.dashboard-panel::after,
	.home-left-column > div:nth-child(3)::after,
	.home-right-column > div::after,
	.map-panel::after,
	.chart-panel::after {
		content: "";
		position: absolute;
		inset: 0;
		border-radius: inherit;
		pointer-events: none;
		box-shadow: inset 0 0 0 1px rgba(176, 226, 255, 0.06);
	}
	.panel-header,
	.home-side-column > div > div:first-child,
	.chart-header {
		position: relative;
		border-bottom: 1px solid rgba(0, 204, 255, 0.28) !important;
		background:
			linear-gradient(90deg, rgba(0, 60, 102, 0.82), rgba(0, 43, 77, 0.36) 58%, rgba(0, 26, 51, 0.14)),
			linear-gradient(180deg, rgba(176, 226, 255, 0.08), transparent) !important;
		box-shadow: inset 0 -1px 0 rgba(0, 153, 255, 0.2);
	}
	.panel-header::after,
	.home-side-column > div > div:first-child::after,
	.chart-header::after {
		content: "";
		position: absolute;
		left: 18px;
		right: 18px;
		bottom: -1px;
		height: 1px;
		background: linear-gradient(90deg, rgba(0, 204, 255, 0.9), rgba(0, 153, 255, 0.18), transparent);
		pointer-events: none;
	}
	.panel-title-icon img,
	.home-side-column > div > div:first-child img,
	.chart-header img {
		max-width: 22px;
		max-height: 22px;
		filter: drop-shadow(0 0 8px rgba(0, 204, 255, 0.34));
	}
	.panel-title,
	.home-side-column > div > div:first-child > div:nth-child(2),
	.chart-header > div:first-child > div:nth-child(2) {
		color: #B0E2FF !important;
		font-size: 15px !important;
		font-weight: 700;
		text-shadow: 0 0 12px rgba(0, 204, 255, 0.42);
	}
	.metric-card,
	.home-right-column > div:first-child > div:nth-child(2) > div,
	.home-right-column > div:nth-child(2) > div:not(:first-child) > div,
	.home-right-column > div:nth-child(3) > div:nth-child(2) > div {
		position: relative;
		overflow: hidden;
		background:
			linear-gradient(180deg, rgba(0, 34, 62, 0.96), rgba(0, 21, 42, 0.96)),
			radial-gradient(circle at 50% 0%, rgba(0, 204, 255, 0.14), transparent 58%) !important;
		border-color: rgba(0, 153, 255, 0.54) !important;
		box-shadow:
			inset 0 1px 0 rgba(176, 226, 255, 0.12),
			inset 0 0 18px rgba(0, 153, 255, 0.1),
			0 8px 18px rgba(0, 8, 22, 0.24) !important;
	}
	.metric-card::before,
	.home-right-column > div:first-child > div:nth-child(2) > div::before,
	.home-right-column > div:nth-child(2) > div:not(:first-child) > div::before,
	.home-right-column > div:nth-child(3) > div:nth-child(2) > div::before {
		content: "";
		position: absolute;
		left: 10px;
		right: 10px;
		top: 0;
		height: 1px;
		background: linear-gradient(90deg, transparent, rgba(0, 204, 255, 0.72), transparent);
		pointer-events: none;
	}
	.metric-value,
	.power-data-grid .metric-card > div:nth-child(3),
	.income-grid .metric-card > div:nth-child(3),
	.home-right-column > div:nth-child(2) > div:not(:first-child) > div > div:last-child,
	.home-right-column > div:nth-child(3) > div:nth-child(2) > div > div:nth-child(3) {
		font-family: "Bahnschrift", "DIN Alternate", "DINAlternate", "Arial Narrow", "Microsoft YaHei", sans-serif !important;
		color: #00CCFF !important;
		letter-spacing: 0 !important;
		text-shadow: 0 0 12px rgba(0, 204, 255, 0.36);
	}
	.home-right-column > div:nth-child(2) label,
	.home-right-column > div:nth-child(3) > div:nth-child(2) > div > div:last-child {
		font-size: 12px !important;
		color: #B0E2FF !important;
		text-shadow: none !important;
	}
	.home-right-column > div:first-child > div:nth-child(2) > div {
		border: 1px solid rgba(0, 153, 255, 0.28);
		border-radius: 6px;
		padding: 10px 6px;
	}
	.home-right-column > div:first-child > div:nth-child(2) > div > div:first-child {
		font-family: "Bahnschrift", "DIN Alternate", "Microsoft YaHei", sans-serif;
	}
	.home-right-column > div:first-child > div:nth-child(2) > div > div:nth-child(3) {
		font-family: "Bahnschrift", "DIN Alternate", "Microsoft YaHei", sans-serif;
		font-size: 15px !important;
		text-shadow: 0 0 10px rgba(0, 204, 255, 0.28);
	}
	.fdxl-table-header,
	.fdxl-scroll-container,
	.warn-scroll-container {
		background: rgba(0, 21, 42, 0.82) !important;
		border-color: rgba(0, 153, 255, 0.42) !important;
	}
	.fdxl-table-header {
		color: #D7F6FF !important;
		background: linear-gradient(90deg, rgba(0, 60, 102, 0.82), rgba(0, 34, 62, 0.9)) !important;
		box-shadow: inset 0 0 16px rgba(0, 153, 255, 0.1);
	}
	.fdxl-scroll-container > div,
	.warn-scroll-container > div {
		border-bottom: 1px solid rgba(0, 60, 102, 0.78) !important;
		background: linear-gradient(90deg, rgba(0, 26, 51, 0.78), rgba(0, 43, 77, 0.26)) !important;
		transition: background-color 0.2s ease, color 0.2s ease;
	}
	.fdxl-scroll-container > div:hover,
	.warn-scroll-container > div:hover {
		background: linear-gradient(90deg, rgba(0, 153, 255, 0.16), rgba(0, 43, 77, 0.38)) !important;
		color: #D7F6FF !important;
	}
	.fdxl-scroll-container > div > div:nth-child(2) > div:first-child > div {
		background: linear-gradient(90deg, #0099FF, #00CCFF) !important;
		box-shadow: 0 0 10px rgba(0, 204, 255, 0.32);
	}
	.map-search /deep/ .el-input__inner,
	.chart-actions /deep/ .el-date-editor {
		background: rgba(0, 21, 42, 0.88) !important;
		border-color: rgba(0, 153, 255, 0.56) !important;
		color: #B0E2FF !important;
		box-shadow: inset 0 0 14px rgba(0, 153, 255, 0.12);
	}
	.map-search /deep/ .el-input__inner {
		height: 38px;
		border-radius: 6px;
	}
	.chart-actions /deep/ .chart-date-range.el-date-editor--daterange {
		position: relative;
		height: 29px !important;
		line-height: 29px !important;
		padding: 0 8px !important;
		border: 0 !important;
		border-radius: 4px !important;
		background: rgba(0, 21, 42, 0.88) !important;
		background-clip: padding-box;
		box-shadow: inset 0 0 14px rgba(0, 153, 255, 0.12) !important;
		display: inline-flex !important;
		align-items: center !important;
	}
	.chart-actions /deep/ .chart-date-range.el-date-editor--daterange::after {
		content: "";
		position: absolute;
		inset: 0;
		border: 1px solid rgba(0, 153, 255, 0.86);
		border-radius: 4px;
		pointer-events: none;
		box-shadow: 0 0 8px rgba(0, 153, 255, 0.18);
	}
	.chart-actions /deep/ .chart-date-range.el-date-editor--daterange .el-range-icon,
	.chart-actions /deep/ .chart-date-range.el-date-editor--daterange .el-range__icon {
		flex: 0 0 18px;
		margin: 0 6px 0 2px !important;
		float: none !important;
		display: inline-flex !important;
		align-items: center;
		justify-content: center;
		height: 29px !important;
		line-height: 29px !important;
		color: #00CCFF !important;
		text-align: center;
		text-shadow: 0 0 8px rgba(0, 204, 255, 0.42);
	}
	.chart-actions /deep/ .chart-date-range.el-date-editor--daterange .el-range-separator {
		flex: 0 0 24px;
		width: 24px !important;
		height: 29px !important;
		padding: 0 !important;
		margin: 0 4px !important;
		display: inline-flex !important;
		align-items: center;
		justify-content: center;
		line-height: 29px !important;
		color: #D7F6FF !important;
		text-align: center;
		font-weight: 700;
		text-shadow: 0 0 8px rgba(0, 204, 255, 0.46);
	}
	.chart-actions /deep/ .chart-date-range.el-date-editor--daterange .el-range-input {
		background: transparent !important;
		box-shadow: none !important;
		border: 0 !important;
		color: #D7F6FF !important;
		height: 29px !important;
		line-height: 29px !important;
		display: inline-flex !important;
		align-items: center;
		justify-content: center;
		font-weight: 600;
		text-shadow: 0 0 8px rgba(0, 204, 255, 0.32);
	}
	.chart-actions /deep/ .chart-date-range.el-date-editor--daterange .el-range-input::placeholder {
		color: rgba(215, 246, 255, 0.72) !important;
	}
	.map-search /deep/ .el-input__suffix {
		right: 10px;
	}
	.map-search /deep/ .el-icon-search {
		color: #00CCFF !important;
		cursor: pointer;
		text-shadow: 0 0 10px rgba(0, 204, 255, 0.45);
	}
	.aaaa1,
	.aaaa2 {
		border-radius: 5px !important;
		font-size: 13px;
		font-weight: 600;
	}
	.aaaa1 {
		background: linear-gradient(180deg, #00B7FF, #007DDE) !important;
		color: #FFFFFF !important;
		box-shadow: 0 0 14px rgba(0, 153, 255, 0.48), inset 0 1px 0 rgba(255, 255, 255, 0.22) !important;
	}
	.aaaa2 {
		background: rgba(0, 21, 42, 0.72) !important;
		border-color: rgba(0, 153, 255, 0.46) !important;
		color: #87CEFA !important;
	}
	.aaaa2:hover {
		border-color: rgba(0, 204, 255, 0.84) !important;
		color: #D7F6FF !important;
		background: rgba(0, 153, 255, 0.18) !important;
	}
	.chart-body,
	.chartsBox,
	.map-panel > div:not(.map-search),
	.amap-demo {
		background-color: rgba(0, 21, 42, 0.88) !important;
	}
	.chartsBox {
		box-shadow: inset 0 0 26px rgba(0, 153, 255, 0.07);
	}
	.home-page /deep/ .el-dialog {
		background:
			linear-gradient(180deg, rgba(0, 43, 77, 0.98), rgba(0, 26, 51, 0.98)) !important;
		border-radius: 8px;
	}
	.power-data-grid .metric-value {
		flex-direction: column !important;
		gap: 3px;
		line-height: 1.1 !important;
		white-space: nowrap !important;
	}
	.power-data-grid .metric-value .metric-number {
		display: block;
		width: 100%;
		color: #00CCFF;
		font-family: "Bahnschrift", "DIN Alternate", "DINAlternate", "Arial Narrow", "Microsoft YaHei", sans-serif;
		font-size: 16px;
		font-weight: 700;
		line-height: 20px;
		text-align: center;
		text-shadow: 0 0 12px rgba(0, 204, 255, 0.36);
	}
	.power-data-grid .metric-value .metric-unit,
	.income-grid .metric-card > div:nth-child(3) .income-value-unit,
	.home-right-column > div:nth-child(2) label,
	.home-right-column > div:nth-child(3) > div:nth-child(2) > div > div:last-child {
		display: block !important;
		margin-top: 2px !important;
		margin-left: 0 !important;
		color: #00CCFF !important;
		font-family: "Bahnschrift", "DIN Alternate", "DINAlternate", "Arial Narrow", "Microsoft YaHei", sans-serif !important;
		font-size: clamp(12px, 0.9vw, 16px) !important;
		font-weight: 700 !important;
		line-height: 18px !important;
		letter-spacing: 0 !important;
		text-align: center !important;
		text-shadow: 0 0 10px rgba(0, 204, 255, 0.28) !important;
	}
	.home-right-column > div:nth-child(2) label {
		display: inline-block !important;
		margin-left: 4px !important;
		vertical-align: baseline;
	}
	.home-right-column > div:nth-child(3) > div:nth-child(2) > div > div:last-child {
		margin-top: 2px !important;
	}
	.power-data-grid .metric-value .metric-number,
	.income-grid .metric-card > div:nth-child(3),
	.home-right-column > div:nth-child(2) > div:not(:first-child) > div > div:last-child,
	.home-right-column > div:nth-child(3) > div:nth-child(2) > div > div:nth-child(3) {
		font-size: 15px !important;
		line-height: 19px !important;
		font-weight: 700 !important;
	}
	.power-data-grid .metric-value .metric-unit,
	.income-grid .metric-card > div:nth-child(3) .income-value-unit,
	.home-right-column > div:nth-child(2) label,
	.home-right-column > div:nth-child(3) > div:nth-child(2) > div > div:last-child {
		font-size: 13px !important;
		line-height: 17px !important;
	}
	.home-right-column > div:nth-child(2) > div:not(:first-child) > div > div:last-child {
		display: flex;
		align-items: baseline;
		justify-content: center;
		gap: 4px;
	}
	.home-right-column > div:nth-child(2) label {
		flex: 0 0 auto;
	}
	.mobile-map-heading {
		display: none;
	}

	@media screen and (max-width: 760px) {
		.home-page {
			display: block;
			width: 100% !important;
			height: 100% !important;
			min-height: 0;
			padding: 10px 10px 24px;
			overflow-x: hidden !important;
			overflow-y: auto !important;
			-webkit-overflow-scrolling: touch;
		}
		.home-page > .home-dashboard {
			display: grid !important;
			grid-template-columns: repeat(2, minmax(0, 1fr));
			align-items: stretch;
			justify-content: flex-start;
			gap: 12px;
			width: 100% !important;
			height: auto !important;
			max-height: none;
			margin: 0 !important;
		}
		.home-side-column,
		.home-center-column {
			display: contents !important;
		}
		.home-side-column > div,
		.map-panel,
		.chart-panel {
			width: 100% !important;
			margin: 0 !important;
			border-radius: 8px !important;
		}
		.power-data-panel {
			order: 3;
			grid-column: 1 / -1;
		}
		.home-right-column > div:nth-child(2) {
			order: 2;
			grid-column: 1 / -1;
		}
		.map-panel {
			order: 1;
			grid-column: 1 / -1;
		}
		.chart-panel {
			order: 4;
			grid-column: 1 / -1;
		}
		.income-panel {
			order: 6;
			grid-column: 1;
		}
		.home-right-column > div:nth-child(3) {
			order: 6;
			grid-column: 2;
		}
		.home-right-column > div:first-child {
			display: none !important;
		}
		.home-left-column > div:nth-child(3) {
			order: 5;
			grid-column: 1 / -1;
		}
		.power-data-panel,
		.home-right-column > div:nth-child(2) {
			height: 240px !important;
		}
		.income-panel,
		.home-right-column > div:nth-child(3) {
			height: 326px !important;
		}
		.home-left-column > div:nth-child(3) {
			height: 300px !important;
		}
		.power-data-grid,
		.income-grid {
			gap: 8px;
			padding: 12px 10px !important;
		}
		.power-data-grid .metric-card,
		.income-grid .metric-card {
			height: 164px !important;
			padding: 12px 5px !important;
		}
		.power-data-grid .metric-card > div:first-child,
		.income-grid .metric-card > div:first-child,
		.metric-label {
			font-size: 12px !important;
		}
		.power-data-grid .metric-card > div:nth-child(2) img,
		.income-grid .metric-card > div:nth-child(2) img,
		.metric-icon img {
			width: 32px !important;
			height: 32px !important;
			min-width: 0;
			min-height: 0;
		}
		.power-data-grid .metric-value .metric-number,
		.income-grid .metric-card > div:nth-child(3) {
			font-size: 14px !important;
		}
		.income-grid {
			flex-direction: column;
			gap: 6px;
			height: calc(100% - 48px) !important;
			padding: 8px !important;
		}
		.income-grid .metric-card {
			display: grid !important;
			grid-template-columns: minmax(0, 1fr) 30px minmax(0, 1fr);
			grid-template-rows: 1fr;
			align-items: center;
			align-content: center;
			flex: 1 1 0;
			width: 100% !important;
			height: auto !important;
			min-height: 0;
			padding: 6px !important;
		}
		.income-grid .metric-card > div {
			width: auto !important;
			height: auto !important;
			min-width: 0;
		}
		.income-grid .metric-card > div:first-child {
			justify-content: flex-start;
			font-size: 11px !important;
			line-height: 16px !important;
			white-space: normal;
		}
		.income-grid .metric-card > div:nth-child(2) img {
			width: 26px !important;
			height: 26px !important;
		}
		.income-grid .metric-card > div:nth-child(3) {
			flex-direction: row;
			align-items: center;
			justify-content: flex-end;
			font-size: 13px !important;
			line-height: 18px !important;
			white-space: nowrap;
		}
		.income-grid .metric-card > div:nth-child(3) .income-value-number,
		.income-grid .metric-card > div:nth-child(3) .income-value-unit {
			display: inline-flex !important;
			align-items: center;
			height: 18px;
			line-height: 18px !important;
			margin: 0 0 0 2px !important;
			font-size: 11px !important;
		}
		.income-grid .metric-card > div:nth-child(3) .income-value-number {
			margin-left: 0 !important;
			font-size: 13px !important;
		}
		.income-grid .metric-card > div:nth-child(3) .income-value-unit {
			transform: translateY(2px);
		}
		.home-left-column > div:nth-child(3) > .fdxl-table-header,
		.home-left-column > div:nth-child(3) > .fdxl-scroll-container {
			width: calc(100% - 20px) !important;
			margin-right: 10px !important;
			margin-left: 10px !important;
		}
		.home-left-column > div:nth-child(3) > .fdxl-table-header {
			margin-top: 12px !important;
		}
		.home-left-column > div:nth-child(3) > .fdxl-scroll-container {
			height: 182px !important;
		}
		.fdxl-table-header > div:first-child,
		.fdxl-scroll-container > div > div:first-child {
			width: 42% !important;
			padding: 0 8px !important;
		}
		.fdxl-table-header > div:nth-child(2),
		.fdxl-scroll-container > div > div:nth-child(2) {
			width: 58% !important;
			grid-template-columns: minmax(40px, 1fr) minmax(76px, auto) !important;
			column-gap: 8px !important;
			padding: 0 8px !important;
		}
		.fdxl-scroll-container > div > div:nth-child(2) > div:first-child,
		.fdxl-scroll-container > div > div:nth-child(2) > div:last-child {
			min-width: 0;
			max-width: none;
		}
		.map-panel {
			height: 360px !important;
		}
		.mobile-map-heading {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			z-index: 100;
			display: flex;
			align-items: center;
			gap: 10px;
			width: 100% !important;
			height: 50px !important;
			padding: 0 14px;
			border-bottom: 1px solid rgba(0, 204, 255, 0.28);
			background: linear-gradient(90deg, rgba(0, 60, 102, 0.96), rgba(0, 34, 62, 0.88));
			box-shadow: 0 8px 18px rgba(0, 8, 22, 0.26);
		}
		.mobile-map-heading i {
			color: #00ccff;
			font-size: 20px;
			text-shadow: 0 0 10px rgba(0, 204, 255, 0.5);
		}
		.mobile-map-heading > div {
			display: flex;
			align-items: baseline;
			gap: 8px;
		}
		.mobile-map-heading strong {
			color: #d7f6ff;
			font-size: 15px;
		}
		.mobile-map-heading span {
			color: #6faec8;
			font-size: 11px;
		}
		.map-search {
			top: 60px !important;
			left: 10px;
			right: 10px;
		}
		.chart-panel {
			height: 390px !important;
		}
		.chart-header {
			display: flex !important;
			flex-wrap: wrap;
			align-content: flex-start;
			gap: 0;
			height: 112px !important;
			padding: 0 12px;
		}
		.chart-header > div:first-child {
			width: 100%;
			height: 44px !important;
		}
		.chart-header > div:first-child > div:first-child {
			margin-left: 0 !important;
		}
		.chart-actions {
			display: flex !important;
			width: 100%;
			height: 62px !important;
			margin: 0 !important;
			justify-content: flex-start;
			row-gap: 5px;
		}
		.chart-actions > .aaaa1,
		.chart-actions > .aaaa2 {
			flex: 1 1 0;
			width: auto;
			min-width: 72px;
			margin-left: 0 !important;
		}
		.chart-actions > .aaaa1 + .aaaa1,
		.chart-actions > .aaaa1 + .aaaa2,
		.chart-actions > .aaaa2 + .aaaa1,
		.chart-actions > .aaaa2 + .aaaa2 {
			margin-left: 8px !important;
		}
		.chart-actions > div:last-child {
			flex: 0 0 100%;
			width: 100%;
			height: 29px !important;
			margin-left: 0 !important;
		}
		.chart-actions /deep/ .chart-date-range.el-date-editor--daterange {
			width: 100% !important;
		}
		.chart-panel > .chart-body {
			height: calc(100% - 112px) !important;
		}
		.home-right-column > div:first-child {
			height: 238px !important;
		}
		.home-right-column > div:nth-child(2) {
			height: 300px !important;
		}
		.home-right-column > div:nth-child(3) {
			height: 326px !important;
		}
		.home-right-column > div:first-child > div:nth-child(2) {
			padding: 12px 4px !important;
		}
		.home-right-column > div:first-child > div:nth-child(2) > div {
			padding: 8px 2px;
		}
		.home-right-column > div:first-child > div:nth-child(2) > div > div {
			font-size: 11px !important;
		}
		.home-right-column > div:first-child > div:nth-child(2) > div > div:first-child,
		.home-right-column > div:first-child > div:nth-child(2) > div > div:nth-child(3) {
			font-size: 13px !important;
		}
		.home-right-column > div:nth-child(2) > div:nth-child(2),
		.home-right-column > div:nth-child(2) > div:nth-child(3) {
			padding: 8px 10px !important;
		}
		.home-right-column > div:nth-child(2) > div:not(:first-child) > div > div:first-child > div:nth-child(2) {
			font-size: 12px !important;
			line-height: 16px;
			text-align: center;
		}
		.home-right-column > div:nth-child(3) > div:nth-child(2) {
			flex-direction: column;
			padding: 8px !important;
			gap: 6px;
		}
		.home-right-column > div:nth-child(3) > div:nth-child(2) > div {
			display: grid !important;
			grid-template-columns: minmax(0, 1fr) 30px auto 14px;
			align-items: center;
			flex: 1 1 0 !important;
			width: 100% !important;
			height: auto !important;
			min-height: 0;
			padding: 6px !important;
		}
		.home-right-column > div:nth-child(3) > div:nth-child(2) > div > div {
			margin: 0 !important;
			font-size: 12px !important;
		}
		.home-right-column > div:nth-child(3) > div:nth-child(2) > div > div:first-child {
			justify-self: start;
			font-size: 11px !important;
		}
		.home-right-column > div:nth-child(3) > div:nth-child(2) > div > div:nth-child(2) img {
			width: 26px !important;
			height: 26px !important;
		}
		.home-right-column > div:nth-child(3) > div:nth-child(2) > div > div:nth-child(3) {
			justify-self: end;
			font-size: 16px !important;
			line-height: 18px !important;
		}
		.home-right-column > div:nth-child(3) > div:nth-child(2) > div > div:nth-child(4) {
			justify-self: start;
			font-size: 11px !important;
			line-height: 18px !important;
			transform: translateY(2px);
		}
		.home-page /deep/ .station-info-dialog {
			width: calc(100% - 20px) !important;
			max-height: calc(100vh - 20px);
			margin: 10px !important;
			overflow-y: auto;
		}
		.home-page /deep/ .station-info-dialog .el-dialog__header {
			padding: 16px !important;
		}
		.home-page /deep/ .station-info-dialog .el-dialog__body {
			padding: 14px !important;
		}
		.home-page /deep/ .station-info-dialog .el-dialog__body > div:first-child {
			flex-direction: column;
			align-items: stretch !important;
			margin-top: 0 !important;
		}
		.home-page /deep/ .station-info-dialog .el-dialog__body > div:first-child > div {
			width: 100%;
			margin: 10px 0 0 !important;
		}
		.home-page /deep/ .station-info-dialog .el-dialog__body > div:first-child > div:first-child {
			margin-top: 0 !important;
		}
		.home-page /deep/ .station-info-dialog .el-dialog__body > div:first-child > div:nth-child(n + 2) > div > div:first-child {
			flex: 0 0 92px;
			width: 92px !important;
			text-align: left !important;
		}
		.home-page /deep/ .station-info-dialog .el-dialog__body > div:last-child {
			flex-wrap: wrap;
			gap: 8px;
		}
		.home-page /deep/ .station-info-dialog .el-dialog__body > div:last-child > div {
			width: calc(50% - 4px) !important;
			margin: 0 !important;
			padding: 8px 4px;
		}
		.home-page /deep/ .station-info-dialog .el-dialog__body > div:last-child > div > div {
			font-size: 12px !important;
		}
	}

	@media screen and (max-width: 360px) {
		.home-page {
			padding-right: 8px;
			padding-left: 8px;
		}
		.power-data-grid,
		.income-grid {
			gap: 5px;
			padding-right: 7px !important;
			padding-left: 7px !important;
		}
		.power-data-grid .metric-card,
		.income-grid .metric-card {
			padding-right: 3px !important;
			padding-left: 3px !important;
		}
	}
</style>
